import { render, staticRenderFns } from "./ContentBlockCreate.vue?vue&type=template&id=0cc20f58&"
import script from "./ContentBlockCreate.vue?vue&type=script&lang=js&"
export * from "./ContentBlockCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports